<div class="d-flex" style="width: 100%">
  <div class="d-flex img-container">
    <img class="img-align" src="./assets/images/bg3.png" alt="background" />
    <div class="centered fw-bold fs-14">Main Menu</div>
  </div>
</div>

<div>
  <div id="setBox">
    <mat-stepper class="mat-nav-list" #stepper orientation="vertical">
      <mat-step
        class="px-1"
        label="{{ menu.name }}"
        *ngFor="let menu of mainmenu"
      >
        <ng-template matStepLabel>{{ menu.name }}</ng-template>

        <ng-template matStepContent>
          <ul class="nav-list mb-0 nodots">
            <ng-container *ngFor="let item of menu.children">
              <li
                (click)="navigateUrl(item.url)"
                routerLinkActive="active"
                class="px-1"
                [class.active]="isUrlMatch(item)"
              >
                {{ item.name }}
              </li>
            </ng-container>
          </ul>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </div>
</div>
